module.exports = __webpack_public_path__ + "67c9da836f5d8c463b82a89b9029b160.jpg";